import Vue from 'vue'
import axios from 'axios'
import {GetCookie,DelCookie} from '../api/cookie'
import notifyIcon from '@/assets/img/msgicon.png'

export const Axios=axios.create({
    baseURL:'https://admin.beimen.com/api/v1/wap'
})

export const AxiosOld=axios.create({
    baseURL:'https://admin.beimen.com/api/v1'
})

export const AxiosOldByToken=axios.create({
    baseURL:'https://admin.beimen.com/api/v1'
})

if(GetCookie('token')){
	Axios.defaults.headers.common['Authorization']=GetCookie('token')
	AxiosOldByToken.defaults.headers.common['Authorization']=GetCookie('token')
}
